export default __webpack_public_path__ + "static/media/distractions1.fdfa6eea.png";